export function iterateDom(node: Node, upperStack: Node[], onProcessNode: (node:Node, upperStack: Node[]) => void){
    onProcessNode(node, upperStack);
    if (node.hasChildNodes()){
        node.childNodes.forEach((child)=>{
            iterateDom(child, [...upperStack, node], onProcessNode);
        })
    }
}

export function cloneRecurvise(node: Node, onProcessNode?: (node: Node, cloned: Node)=>void){
    let res: Node = null;
    let clonedStack: Node[] = [];
    iterateDom(node, [], (processing, stack)=>{
        if (res == null){
            res = processing.cloneNode(false);
            onProcessNode?.(processing, res);
            clonedStack.push(res);
        } else {
            if (stack.length < clonedStack.length){
                clonedStack = clonedStack.slice(0, stack.length);
            }
            const cloned = processing.cloneNode(false);
            onProcessNode?.(processing, cloned);
            const topStack = clonedStack[clonedStack.length-1];
            topStack.appendChild(cloned);
            clonedStack.push(cloned);
            /*if (stack.length > clonedStack.length){
                const cloned = processing.cloneNode(false);
                const topStack = clonedStack[clonedStack.length-1];
                topStack.appendChild(cloned);
                clonedStack.push(cloned);
            }
            else if (stack.length == clonedStack.length) {
                const cloned = processing.cloneNode(false);
                const topStack = clonedStack[clonedStack.length-1];
                topStack.appendChild(cloned);
                clonedStack.push(cloned);
            } else {
                clonedStack = clonedStack.slice(0, stack.length);
                const topStack = clonedStack[clonedStack.length-1];
                const cloned = processing.cloneNode(false);
                topStack.appendChild(cloned);
                clonedStack.push(cloned);
            }*/
        }
    });
    console.log('rec', res);
    return res;
}

export function iterateDomUp(node: Node, onProcessNode: (node:Node) => void){
    if (!node){
        return;
    }
    onProcessNode(node);
    if (node.parentNode){
        iterateDomUp(node.parentNode, onProcessNode);
    }
}

export function deepestTextNode(node: Node, offset: number){
    if (node && !(node instanceof Text)){
        return deepestTextNode(node.childNodes[offset], 0);
    }
    return {
        node: node,
        offset: offset
    }
}

export function deepestEmptyOrTextNode(node: Node, offset: number){
    if (node && !(node instanceof Text)){
        if (node.childNodes.length == 0){
            return {
                node: node,
                offset: 0
            }
        }
        return deepestTextNode(node.childNodes[offset], 0);
    }
    return {
        node: node,
        offset: offset
    }
}

export function deepestTextNodeRight(node: Node){
    if (node && !(node instanceof Text)){
        return deepestTextNodeRight(node.childNodes[node.childNodes.length-1]);
    }
    return {
        node: node,
        offset: node?.textContent.length || 0
    }
}